import React from "react";
import {
  Truck,
  Shield,
  Droplet,
  Tag,
  Clock,
  Award,
} from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const ICONS = [Truck, Shield, Droplet, Tag, Clock, Award];

const WhyUs = () => {
  const { t } = useLang();
  return (
    <section
      id="why-us"
      className="py-24 md:py-32 relative"
      data-testid="why-us-section"
    >
      <div className="container-hd">
        <div className="max-w-3xl mb-12">
          <div className="font-serif italic text-[color:var(--hd-gold)] text-sm md:text-base mb-3">
            — {t.why.overline}
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-bold text-white tracking-tight">
            {t.why.title}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="why-grid">
          {t.why.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                className="card-hover rounded-2xl p-7 md:p-8"
                data-testid={`why-item-${i}`}
              >
                <div className="w-12 h-12 rounded-xl bg-[color:var(--hd-gold)]/10 border border-[color:var(--hd-gold)]/30 flex items-center justify-center mb-5">
                  <Icon className="text-[color:var(--hd-gold)]" size={22} />
                </div>
                <h3 className="font-display text-xl font-bold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
